import { render } from "./myArchive.vue?vue&type=template&id=c66d1e34&scoped=true"
import script from "./myArchive.vue?vue&type=script&lang=js"
export * from "./myArchive.vue?vue&type=script&lang=js"

import "./myArchive.vue?vue&type=style&index=0&id=c66d1e34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c66d1e34"]])

export default __exports__